import React, { useEffect, FC, useState } from 'react';
import styles from './MaintenanceTriggers.module.scss';
import { Table, Button } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { MaintenanceTrigger } from './MaintenanceTrigger/MaintenanceTriggerForm.slice';
import { MaintenanceTriggerColumns } from './MaintenanceTrigger/Helpers';
import axios from '../../axios';

export const MaintenanceTriggerTable: FC<RouteComponentProps> = ({ history }) => {
  const [maintenanceTriggers, setMaintenanceTriggers] = useState<MaintenanceTrigger[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const goToCreateMaintenanceTriggers = () => {
    history.push('/create-maintenance-triggers');
  };

  const goToEditMaitananceTrigger = (id: string) => {
    history.push(`/maintenance-triggers/${id}`);
  };

  const getTriggers = async () => {
    setIsLoading(true);
    const url = `MaintenanceTrigger/all`;
    try {
      const response = await axios.get<MaintenanceTrigger[]>(url);
      setMaintenanceTriggers(response.data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTriggers();
  }, []);

  return (
    <div className={styles.tableContainer}>
      <Button onClick={goToCreateMaintenanceTriggers}>Create Maintenance Trigger</Button>
      <Table
        loading={isLoading}
        columns={MaintenanceTriggerColumns}
        className={styles.triggersTable}
        dataSource={maintenanceTriggers}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => goToEditMaitananceTrigger(record.id)
          };
        }}
        pagination={false}
        scroll={{ y: 650 }}
      />
    </div>
  );
};

export default MaintenanceTriggerTable;
